/** Owner-approved Explore release; this switch does not approve curricula or mastery. */
export function earthSciencePreviewEnabled(
  env: { PROD?: boolean; VITE_STUDY_EARTH_SCIENCE_TOOLS?: string; VITE_EARTH_SCIENCE_TOOLS_ENABLED?: string } = import.meta.env,
): boolean {
  return env.VITE_STUDY_EARTH_SCIENCE_TOOLS === '1' ||
    (env.PROD !== true && env.VITE_EARTH_SCIENCE_TOOLS_ENABLED === 'true');
}
